<template>
  <v-form-group :label="label"
                :description="description"
                :error="error"
                :state="errorState">
    <b-form-input @input="handleInput"
                  :value="input"
                  :type="type"
                  :placeholder="placeholder"
                  :readonly="readonly"
                  :state="errorState"
    />
  </v-form-group>
</template>

<script>
import field from "../../Mixins/field";

export default {
  mixins: [field],
  props: ['type']
}
</script>